<template>
  <div>
    <!-- 설정:: 링크 -->
    <div v-if="mode === 'link'" class="setLink">
      <div v-if="Object.keys(link).length === 0"></div>
      <div v-else>
        <SetFloatingPage
          v-if="link.type === 'page'"
          :key="link.id"
          :locale="locale"
          :link="link"
          :floatingPageData="floatingPageData"
          class="mb30"
          @update="updateFloatingPage" />
        <SetLink :link="link" />
      </div>
    </div>
    <div v-else class="message">{{locale.floating_info_select}}</div>
  </div>
</template>

<script>
import SetLink from '@/components/Util/SetLink'
import SetFloatingPage from '@/components/Floating/SetFloatingPage'

export default {
  name: 'SetFloatingUnit',
  props: [
    'locale',
    'mode',
    'link',
    'floatingPageData'
  ],
  components: {
    SetLink,
    SetFloatingPage
  },
  methods: {
    updateFloatingPage (data) {
      this.$emit('updateFloatingPage', data)
    }
  }
}
</script>
